import { LockKey, DeviceMobile, ClipboardText, CloudCheck, Database, Export, Check } from "@phosphor-icons/react";
import MarkerStroke from "./MarkerStroke";
import useReveal from "./useReveal";
import "./home.css";
import "./HomeSecurity.css";

/*
 * Security & compliance — dark editorial section. Claims here mirror the
 * "האם המידע מאובטח" FAQ answer + the trust strip; keep them consistent.
 */

const PILLARS = [
  {
    icon: LockKey,
    title: "הצפנה מקצה לקצה",
    text: "כל המידע מוצפן בתקן AES-256 במנוחה ובתעבורה (TLS). אף אחד מלבדכם לא רואה את תיקי המטופלים.",
  },
  {
    icon: CloudCheck,
    title: "תשתית Google Cloud",
    text: "שרתים מאובטחים בתקן SOC 2 עם גיבויים אוטומטיים וזמינות של 99.9% — הקליניקה לא נעצרת.",
  },
  {
    icon: DeviceMobile,
    title: "כניסה מאומתת בנייד",
    text: "התחברות בקוד SMS חד-פעמי לטלפון האישי בלבד. בלי סיסמאות שאפשר לנחש או לגנוב.",
  },
  {
    icon: ClipboardText,
    title: "תואם דרישות משרד הבריאות",
    text: "אישורי הגעה, חתימה על טפסים ושאלונים למטופלים עוברים אימות זהות — בלי גישה ישירה למאגר.",
  },
  {
    icon: Database,
    title: "מאגר מידע רשום",
    text: "פועלים לפי חוק הגנת הפרטיות ותקנות אבטחת המידע בישראל, ובהתאם לעקרונות GDPR.",
  },
  {
    icon: Export,
    title: "המידע שלכם. תמיד.",
    text: "יומן פעילות מלא על כל פעולה, וייצוא הנתונים בכל רגע. אין נעילה ואין הפתעות.",
  },
];

const CHECKS = ["ללא גישה לצד שלישי", "רשומות רפואיות לא נמחקות", "גיבוי יומי אוטומטי"];

function HomeSecurity() {
  const ref = useReveal();

  return (
    <section id="security" className="home-section home-section--gray hsec" aria-labelledby="hsec-title">
      <div className="home-container">
        <div className="hsec-grid">
          <div className="hsec-copy">
            <h2 id="hsec-title" className="home-h2 home-h2--display hsec-title">
              מידע רפואי דורש יותר מ״מאובטח״.{" "}
              <br />
              הוא דורש{" "}
              <span className="home-mark">
                אחריות.
                <MarkerStroke />
              </span>
            </h2>
            <p className="home-sub">
              CliniKit נבנתה מהיום הראשון סביב סודיות מטופלים: הצפנה, אימות זהות,
              יומן פעילות ותאימות לרגולציה הישראלית — כדי שתוכלו להתרכז בטיפול.
            </p>

            <ul className="hsec-checks home-bubble--lg">
              {CHECKS.map((item) => (
                <li key={item}>
                  <span className="hsec-check-icon">
                    <Check size={14} weight="bold" />
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="hsec-pillars home-reveal" ref={ref}>
            {PILLARS.map((pillar) => {
              const Icon = pillar.icon;
              return (
                <div className="hsec-pillar" key={pillar.title}>
                  <span className="hsec-pillar-icon home-bubble">
                    <Icon size={22} weight="duotone" />
                  </span>
                  <h3>{pillar.title}</h3>
                  <p>{pillar.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default HomeSecurity;
